import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

function Home(props) {

    const navigate = useNavigate();

    function addBulkContacts(){
        navigate("/upload")
    }


    function contacts(){
        navigate("/")
    }


    function addAContacts(){
        navigate("/form")
    }


    useEffect(() => {

        if (!sessionStorage.getItem("isAdmin")) {
            // console.log("not user")
            navigate("/")

        } else {
            // console.log("Logged In")
        }
    }, [])


    return (
        <div>
            <h3 id='panelhead'>Admin Panel</h3>

            <div id='Options'>


                <div className='opt1 opt' onClick={()=>addBulkContacts()} >Add Bulk Contacts</div>
                <div className='opt2 opt' onClick={()=>addAContacts()}> Add a Contact </div>
                <div className='opt3 opt' onClick={()=>contacts()}> View All Contacts</div>


            </div>




        </div>
    )
}

export default Home